import { Table, Typography, Button, Tooltip } from "antd";
import Layout from "../../../Containers/Layout";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getLaboratoryCapacity } from "../../../Requests/laboratory-data-requests";
import { downloadExcel } from "../../../utils/downloadUtils";
import { openNotification, NOTIFICATION_TYPES } from "../../Notifications/NotificationsUtils";
import { getStudyProgram } from "../../../Requests/study-program-request";
import { DownloadOutlined } from "@ant-design/icons";
import { LaboratoryCategoryEnum } from "../../../Api";

const { Title } = Typography;

const columns = [
  {
	title: "Nr. crt.",
	dataIndex: "no",
	key: "no",
	width: 100,
  },
  {
	title: "Număr",
	dataIndex: "roomNumber",
	key: "roomNumber",
  },
  {
	title: "Nume",
	dataIndex: "roomName",
	key: "roomName",
  },
  {
	title: "Suprafață (mp)",
	dataIndex: "area",
	key: "area",
  },
  {
	title: "Capacitate",
	dataIndex: "capacity",
	key: "capacity",
  },
  {
	title: "Suprafață (mp) / Capacitate",
	dataIndex: "ratio",
	key: "ratio",
  },
];

const LaboratoriesTable = () => {

  const { programId, schoolYear } = useParams<{ programId: string, schoolYear: string }>();

  const { data, isLoading, error } = useQuery(
	['getRoomData', programId, schoolYear],
	async () => {
	  const response = await getLaboratoryCapacity(programId, Number(schoolYear));
	  return response;
	}
  );

  const { data: program } = useQuery(
	  ["getProgram", programId], 
	  () => getStudyProgram(programId)
	);

  const roomCapacityData = data || [];

  const informaticLabs = roomCapacityData.filter((item) => item.type === "Informatic");
  const technologicLabs = roomCapacityData.filter((item) => item.type === "Technological");

	const downloadReport = async () => {
		let fileName = 'Capacități Laboratoare - ' + (program?.name ?? '') + '.xlsx';
		return downloadExcel(fileName, columns.map(e => { return { header: e.title, key: e.key?.toString() ?? '' } }).concat({ header: "Tip", key: "type" }),
			roomCapacityData.map(lab => {
				return {
				...lab,
				type: lab.type === LaboratoryCategoryEnum.Technological ? "Tehnologic" : "Informatic"
				}
			}))
		.then(
		() => {
			openNotification("Succes!", "Raportul a fost descărcat cu succes!", NOTIFICATION_TYPES.SUCCESS);
		},
		() => {
			openNotification("Eroare!", "Raportul nu a putut fi descărcat cu succes!", NOTIFICATION_TYPES.ERROR);
		});
	}

  return (
	<Layout>
	  <div>
			<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
				<Title level={3} style={{ margin: 0 }}>
					Laboratoare informatic - {program?.name}
				</Title>
				<Tooltip title="Descărcare raport">
					<Button
					type="primary"
					icon={<DownloadOutlined />}
					onClick={downloadReport}
					>
					Descărcare raport
					</Button>
				</Tooltip>
			</div>
			<Table
			  columns={columns}
			  dataSource={informaticLabs}
			  bordered
			  rowKey={(record) => `${record.type}-${record.no}`}
			  pagination={false}
			/>
			<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20, marginTop: 20 }}>
				<Title level={3} style={{ margin: 0 }}>
					Laboratoare tehnologic - {program?.name}
				</Title>
			</div>
			<Table
			  columns={columns}
			  dataSource={technologicLabs}
			  bordered
			  rowKey={(record) => `${record.type}-${record.no}`}
			  pagination={false}
			/>
	  </div>
	</Layout>
  );
};

export default LaboratoriesTable;